import React, { useState, useEffect } from "react";

//-----------Redux-----------
import { connect } from "react-redux";
import { nextCard, preCard, resetCard } from "../../redux/slices/CardSlices";

//-----------Swiper-----------
import { Swiper, SwiperSlide, useSwiperSlide } from "swiper/react";
import { Navigation, Mousewheel, Keyboard } from "swiper";
import { useSwiper } from "swiper/react";

//-----------Mui-----------
import { Box, Typography, Tooltip } from "@mui/material";

//-----------Icons-----------
import tick from "../../assets/icons/tick.png";
import DoneMark from "../../assets/icons/DoneMark.png";

//-----------css-----------
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./docsSwiper.scss";
import { useTranslation } from "react-i18next";
import {
  getKeyFromText,
  getUserIdFromLocalStorage,
} from "../../utils/Utilities";

const CustomDocSwiper = (props) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const {
    tab,
    custom,
    resetCard,
    list,
    maxWidthSwiper,
    data,
    showTooltip = true,
    handleSubmitStatus = null,
  } = props;
  const [display, setDisplay] = useState(false);
  const ListItemsLength = list.length;

  const postData = async () => {
    if (
      tab == list.length &&
      list[list.length - 1]?.stepStatus === 2 &&
      handleSubmitStatus !== null
    ) {
      await handleSubmitStatus({ ...data, stepStatus: 2 }, uID);
    }
  };
  useEffect(() => {
    if (data !== null) {
      postData();
    }
  }, [data]);
  useEffect(() => {
    if (tab == list.length) {
      setDisplay(true);
      setTimeout(() => {
        setDisplay(false);
      }, 3000);
    }
  }, [tab]);
  const renderMark = (item) => {
    if (tab > item.id && item.stepStatus === 2) {
      return (
        <Box
          component="img"
          src={tick}
          width="15px"
          sx={{
            cursor: "pointer",
            zIndex: 2,
          }}
          onClick={() => {
            props.nextCard();
          }}
        />
      );
    }

    if (tab > item.id && item.stepStatus < 2) {
      return (
        <Box
          component="div"
          sx={{
            cursor: "pointer",
            zIndex: 1,
          }}
          onClick={() => {
            props.nextCard();
          }}
        >
          <Typography fontWeight="bold" fontSize="19px">
            !
          </Typography>
        </Box>
      );
    }

    if (tab == list.length && item.stepStatus === 2) {
      return (
        <Box
          component="img"
          src={DoneMark}
          width="17px"
          sx={{
            cursor: "pointer",
            zIndex: 2,
          }}
        />
      );
    }
  };

  let maxWidthFirstELStyle = {
    left: "20%",
  };
  let maxWidthLaststELStyle = {
    left: "80%",
  };
  const getBackgroundColor = (item, index) => {
    if (tab >= item.id) {
      if (index === list.length - 1) {
        return "color.magentaDark1";
      } else {
        return "color.magentaLight2";
      }
    } else {
      return "color.magentaMid2";
    }
  };
  return (
    <>
      <Box className="custom-swiper-container">
        <Swiper
          cssMode={true}
          breakpoints={{
            // when window width is >= 320px
            280: {
              slidesPerView: 1,
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 2,
            },
            // when window width is >= 640px

            640: {
              slidesPerView: 3,
              //   slidesPerGroup: 1,
            },
            // when window width is >= 900px
            900: {
              slidesPerView: Math.ceil(ListItemsLength),
            },
            1200: {
              slidesPerView: Math.ceil(ListItemsLength),
            },
          }}
          navigation={true}
          mousewheel={true}
          keyboard={true}
          modules={[Navigation, Mousewheel, Keyboard]}
          className="custom-doc-swiper"
        >
          {list?.map((item, index, arr) => (
            <SwiperSlide className="swiper-slide" key={item.name}>
              <Box
                component="div"
                display="flex"
                alignItems="flex-end"
                height="60px"
              >
                <Box
                  className="text-container"
                  component="div"
                  sx={{
                    position: "absolute",
                    left: "50%",
                    top: "0%",
                    transform: "translate(-50%,0%)",
                    ...(!maxWidthSwiper && {
                      width: "100% ",
                      textAlign: "center",
                    }),
                    ...(maxWidthSwiper && index === 0 && maxWidthFirstELStyle),
                    ...(maxWidthSwiper &&
                      index === ListItemsLength - 1 &&
                      maxWidthLaststELStyle),
                  }}
                >
                  <Typography
                    className="swiper-text"
                    variant="inherit"
                    lineHeight="16px"
                    fontWeight="400"
                    sx={{ fontSize: "Max(10px,1vw)" }}
                  >
                    {showTooltip ? <>
                      {t(getKeyFromText(item.name))?.length > 8 ? (
                        <Tooltip title={t(getKeyFromText(item.name))}>
                          <Typography>{t(getKeyFromText(item.name)).slice(0, 8)}...</Typography>
                        </Tooltip>
                      ) : (
                        <Typography>{t(getKeyFromText(item.name))}</Typography>
                      )}
                    </> : <><Typography>{t(getKeyFromText(item.name))}</Typography></>
                    }
                  </Typography>
                </Box>
                <Box
                  className={`horizontal-bar-first ${index !== 0 ? "" : "hide"
                    }`}
                  sx={{
                    backgroundColor: "color.magentaMid2",
                    ...(maxWidthSwiper &&
                      index === 0 && { width: "20% !important" }),
                    ...(maxWidthSwiper &&
                      index === ListItemsLength - 1 && {
                      width: "80% !important",
                    }),
                  }}
                />
                <Box
                  className="circle-container"
                  sx={{
                    borderRadius: "50%",
                    position: "absolute",
                    left: "50%",
                    top: "calc(100% - 3px)",
                    cursor: "pointer",
                    boxShadow: "0px 0px 3px 2px rgba(0,0,0,0.12)",
                    transform: "translate(-50%,-100%)",
                    ...(maxWidthSwiper && index === 0 && maxWidthFirstELStyle),
                    ...(maxWidthSwiper &&
                      index === ListItemsLength - 1 &&
                      maxWidthLaststELStyle),
                  }}
                >
                  <Box
                    className="circle"
                    sx={{
                      position: "relative",
                      color: tab === item.id ? "#444561" : "#957ba0",
                      backgroundColor: getBackgroundColor(item, index),
                    }}
                    onClick={() => {
                      custom(index + 1);
                      resetCard();
                    }}
                  >
                    {renderMark(item)}
                  </Box>
                </Box>
                <Box
                  className={`horizontal-bar-second ${index !== arr.length - 1 ? "" : "hide"
                    }`}
                  sx={{
                    backgroundColor: "color.magentaMid2",
                    ...(maxWidthSwiper &&
                      index === 0 && { width: "80% !important" }),
                    ...(maxWidthSwiper &&
                      index === ListItemsLength - 1 && {
                      width: "20% !important",
                    }),
                  }}
                />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
        {display && (
          <Box
            component="div"
            position="absolute"
            backgroundColor="color.magentaLight2"
            width="280px"
            zIndex="2"
            borderRadius="10px"
            padding="1.5rem"
            boxShadow={3}
            left="calc(100% - 85px)"
            top="65%"
            sx={{ transform: "translate(-50%, 12%)" }}
          >
            <Typography>{t("overview-message")}</Typography>
          </Box>
        )}
      </Box >
    </>
  );
};
function mapStateToProps(state) {
  return {
    currentCard: state.currentCard.currentCard,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    nextCard: () => dispatch(nextCard()),
    preCard: () => dispatch(preCard()),
    resetCard: () => dispatch(resetCard()),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CustomDocSwiper);
